import { inject } from "vue";
import store from "@/store";

const useSetFilterRules = () => {
  const eventBus: any = inject("eventBus");

  /**
   * Emits event for focus of search input
   * and set filter rules from event payload.
   */
  const handleTagClick = ({ type = "", values, text }) => {
    // @ts-ignore
    const { valuesMap } = store.state.filterRules;
    const filterRule = store.getters["filterRules/getFilterRule"]({
      type,
      values
    });
    if (!filterRule) {
      eventBus.$emit("contextual-navigation");
      store.commit("filterRules/addFilterRule", {
        filterRule: { type, values }
      });
      store.commit("filterRules/setValuesMap", {
        ...valuesMap,
        [type]: {
          ...valuesMap[type],
          [values.join()]: text
        }
      });
    }
  };

  return {
    handleTagClick
  };
};
export default useSetFilterRules;
